import { render, staticRenderFns } from "./MultipleUploader.vue?vue&type=template&id=70107c8a"
import script from "./MultipleUploader.vue?vue&type=script&lang=js"
export * from "./MultipleUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports